var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2159874047b1723a426f813f93b1176cdb80bacc"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sgdbf-objectifrge-front@pia-production"]={id:"2159874047b1723a426f813f93b1176cdb80bacc"};
      